import {
  userService
} from '../_services'
import moment from 'moment'

/*
const expousers = JSON.parse(localStorage.getItem('expousers'));
baseArray.all = expousers.data;
const state = baseArray;
console.log(baseArray); */

const state = {
  all: {
    data: {},
    loading: true,
    error: {}
  },
  current: {
    data: {},
    loading: {},
    updating: {},
    error: {}
  },
  currentUser: {
    data: {},
    loading: {},
    updating: {},
    error: {}
  }
}

const actions = {
  getAll({
    commit
  }) {
    // if(!expousers) {

    commit('getAllRequest')
    userService.getAll()
      .then(
        users => commit('getAllSuccess', users),
        error => commit('getAllFailure', error)
      )

    // }
  },

  /*   getById ({
      commit
    }, id) {
      commit('getByIdRequest')
  
      userService.getById(id)
        .then(
          users => commit('getByIdSuccess', users),
          error => commit('getByIdFailure', error)
        )
    }, */

  getById({ commit }, id) {

    commit('getByIdRequest');
    return new Promise((resolve, reject) => {
      userService.getById(id).then(user => {
        commit('getByIdSuccess', user);
        resolve();
      }).catch(error => {
        commit('getByIdFailure', error);
        reject();
      });
    });
  },



  deleteUser({
    dispatch,
    commit
  }, id) {
    commit('deleteRequest', id)

    userService.delete(id)
      .then(
        user => {
          dispatch('alert/success', 'Registro eliminado', {
            root: true
          }),
            commit('deleteSuccess', id)
        },
        error => {
          dispatch('alert/error', 'Se ha producido un error', {
            root: true
          }),
            commit('deleteFailure', {
              id,
              error: error.toString()
            })
        }
      )
  },

  updateUser({
    dispatch,
    commit
  }, userData) {
    commit('updateRequest')

    userService.update(userData)
      .then(
        user => {
          dispatch('alert/success', 'Registro actualizado', {
            root: true
          }),
            commit('updateSuccess', user)
        },
        error => {
          dispatch('alert/error', {
            text: 'Se ha producido un error',
            data: error
          }, {
            root: true
          }),
            commit('updateFailure', error)
        }
      )
  }

  /*
     UserDogs
     */

}

const mutations = {
  /*
    ALL
     */
  getAllRequest(state) {
    state.all.loading = true
  },
  getAllSuccess(state, users) {
    state.all.loading = false
    state.all.data = users.data
  },
  getAllFailure(state, error) {
    state.all.loading = false
    state.all.error = error
  },

  updateRequest(state) {
    state.current.updating = true
    state.currentUser.updating = true
  },
  updateSuccess(state, dogs) {
    state.current.updating = false
    state.currentUser.updating = false
    // state.all = { items: users };
  },
  updateFailure(state, error) {
    state.current.updating = false
    state.current.error = error
    state.currentUser.updating = false
    state.currentUser.error = error
  },
  /*
    ById
     */
  getByIdRequest(state) {
    state.current.loading = true
    state.currentUser.loading = true
  },
  getByIdSuccess(state, user) {
    state.current.loading = false
    state.current.data = user.data
    state.currentUser.loading = false
    state.currentUser.data = user.data
  },
  getByIdFailure(state, error) {
    state.current.loading = false
    state.current.data = null
    state.currentUser.loading = false
    state.currentUser.error = error
  },
  deleteRequest(state, id) {
    // add 'deleting:true' property to user being deleted
    state.all.items.data = state.all.items.data.map(user =>
      user.id === id
        ? {
          ...user,
          deleting: true
        }
        : user
    )
  },
  deleteSuccess(state, id) {
    // remove deleted user from state
    state.all.data = state.all.data.filter(user => user.id !== id)
  },
  deleteFailure(state, {
    id,
    error
  }) {
    // remove 'deleting:true' property and add 'deleteError:[error]' property to user
    state.all.data = state.all.data.map(user => {
      if (user.id === id) {
        // make copy of user without 'deleting:true' property
        const {
          deleting,
          ...userCopy
        } = user
        // return copy of user with 'deleteError:[error]' property
        return {
          ...userCopy,
          deleteError: error
        }
      }

      return user
    })
  },

  /*
    DOG
     */
  createDogSuccess(state, dogs) {
    state.current.data.dogs.push(dogs.data)
  },
  updateDogSuccess(state, dogs) {
    const id = dogs.data.id
    var dog = state.current.data.dogs.find(dogs => dogs.id === id)
    dogs.data.birth_date = dogs.data.birth_date.date
    dogs.data.birth = moment(String(dogs.data.birth_date)).format('DD/MM/YYYY')
    Object.assign(dog, dogs.data)
  },
  deleteDogSuccess(state, id) {
    state.current.data.dogs = state.current.data.dogs.filter(dog => dog.id !== id)
  },

  /*
    PHONE
   */
  createPhoneSuccess(state, phones) {
    state.current.data.phones.push(phones.data)
  },
  updatePhoneSuccess(state, phones) {
    const id = phones.data.id
    var phone = state.current.data.phones.find(phones => phones.id === id)
    Object.assign(phone, phones.data)
  },
  deletePhoneSuccess(state, id) {
    state.current.data.phones = state.current.data.phones.filter(phone => phone.id !== id)
  }

}

export const users = {
  namespaced: true,
  state,
  actions,
  mutations
}
